module.exports = __webpack_public_path__ + "img/calendar.2aa9d48f.svg";